export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/v1/admin/auth/login',
    ME: '/v1/admin/auth/me',
    ME_PASSWORD: '/v1/admin/auth/me/password',
    ME_SESSIONS: '/v1/admin/auth/me/sessions',
  },
  USERS: {
    LIST: '/v1/admin/users',
    LOCATION_SUGGESTIONS: '/v1/admin/users/location-suggestions',
    DETAIL: (id: string) => `/v1/admin/users/${id}`,
    STATUS: (id: string) => `/v1/admin/users/${id}/status`,
    DELETE: (id: string) => `/v1/admin/users/${id}`,
    FOLLOWERS: (id: string) => `/v1/admin/users/${id}/followers`,
    FOLLOWING: (id: string) => `/v1/admin/users/${id}/following`,
    INTERESTS: (id: string) => `/v1/admin/users/${id}/interests`,
    TRIBES: (id: string) => `/v1/admin/users/${id}/tribes`,
  },
  TRIBES: {
    LIST: '/v1/admin/tribes',
    LOCATION_SUGGESTIONS: '/v1/admin/tribes/location-suggestions',
    DETAIL: (id: string) => `/v1/admin/tribes/${id}`,
    STATUS: (id: string) => `/v1/admin/tribes/${id}/status`,
    DELETE: (id: string) => `/v1/admin/tribes/${id}`,
    MEMBERS: (id: string) => `/v1/admin/tribes/${id}/members`,
  },
  MESSAGING: {
    REPORTED_CHATS: '/v1/admin/messaging/reported-chats',
  },
  CONTENT: {
    POSTS: '/v1/admin/content/posts',
    TRENDING_POSTS: '/v1/admin/content/posts/trending',
    POST_LOCATION_SUGGESTIONS: '/v1/admin/content/posts/location-suggestions',
    POST_DETAIL: (id: string) => `/v1/admin/content/posts/${id}`,
    POST_STATUS: (id: string) => `/v1/admin/content/posts/${id}/status`,
    POST_DELETE: (id: string) => `/v1/admin/content/posts/${id}`,
    REPORTED_POSTS: '/v1/admin/content/reports/posts',
    FILTER_ANALYTICS: '/v1/admin/analytics/filter-usage',
  },
  RATINGS: {
    STATS: '/v1/admin/ratings/stats',
  },
  REPORTS: {
    LIST: '/v1/admin/reports',
    DETAIL: (id: string) => `/v1/admin/reports/${id}`,
    UPDATE: (id: string) => `/v1/admin/reports/${id}`,
    RESOLVE: (id: string) => `/v1/admin/reports/${id}/resolve`,
  },
  CATEGORIES: {
    LIST: '/v1/admin/interest-categories',
    HIERARCHY: '/v1/admin/interest-categories/hierarchy',
    DETAIL: (id: string) => `/v1/admin/interest-categories/${id}`,
    CREATE: '/v1/admin/interest-categories',
    UPDATE: (id: string) => `/v1/admin/interest-categories/${id}`,
    STATUS: (id: string) => `/v1/admin/interest-categories/${id}/status`,
    USERS: (id: string) => `/v1/admin/interest-categories/${id}/users`,
    TRIBES: (id: string) => `/v1/admin/interest-categories/${id}/tribes`,
  },
  VISIBILITY_RULES: {
    GET: '/v1/admin/visibility-rules',
    PUT: '/v1/admin/visibility-rules',
  },
  AGE_CONFIG: {
    LIST: '/v1/admin/age-config',
    DETAIL: (id: string) => `/v1/admin/age-config/${id}`,
    COUNTRY_REGION: '/v1/admin/age-config/country-region',
    COUNTRY_REGION_DETAIL: (id: string) => `/v1/admin/age-config/country-region/${id}`,
  },
  AUDIT: {
    ADMIN_ACTIVITY: '/v1/admin/audit/admin-activity',
    USER_ACTIVITY: '/v1/admin/audit/user-activity',
    ADMIN_ACTIVITY_FOR_ADMIN: (adminId: string) => `/v1/admin/audit/admins/${adminId}/activity`,
  },
  SUPPORT: {
    TICKETS: '/v1/admin/support/tickets',
    TICKET_DETAIL: (id: string) => `/v1/admin/support/tickets/${id}`,
    TICKET_STATUS: (id: string) => `/v1/admin/support/tickets/${id}/status`,
    TICKET_RESPONSES: (id: string) => `/v1/admin/support/tickets/${id}/responses`,
  },
  POLICIES: {
    LIST: '/v1/admin/policies',
    DETAIL: (id: string) => `/v1/admin/policies/${id}`,
    PUBLIC_BY_TYPE: (type: string) => `/v1/public/policies/${type}`,
  },
  ADMINS: {
    LIST: '/v1/admin/admins',
    DETAIL: (id: string) => `/v1/admin/admins/${id}`,
    INVITE: '/v1/admin/admins/invite',
    STATUS: (id: string) => `/v1/admin/admins/${id}/status`,
    ROLES: (id: string) => `/v1/admin/admins/${id}/roles`,
  },
  ROLES: {
    LIST: '/v1/admin/roles',
    DETAIL: (id: string) => `/v1/admin/roles/${id}`,
    PERMISSIONS: (id: string) => `/v1/admin/roles/${id}/permissions`,
  },
  FILES: {
    AVATAR_PRESIGN: '/v1/auth/me/avatar/presign',
    PRESIGN_GET: '/v1/admin/files/presign-get',
    PRESIGN_UPLOAD: '/v1/admin/files/presign-upload',
  },
  DASHBOARD: {
    STATS: '/v1/admin/dashboard/stats',
    CHARTS: '/v1/admin/dashboard/charts',
  },
  NOTIFICATIONS: {
    TEMPLATES: '/v1/admin/notifications/templates',
    TEMPLATE_DETAIL: (id: string) => `/v1/admin/notifications/templates/${id}`,
    BROADCAST: '/v1/admin/notifications/broadcast',
    LOGS: '/v1/admin/notifications/delivery-logs',
    STATS: '/v1/admin/notifications/stats',
  },
  ANALYTICS: {
    DATA: '/v1/admin/analytics/data',
  },
  FEED_RANKING_CONFIG: {
    BASE: '/v1/admin/feed-ranking-config',
  },
  MAP_DISCOVERY_CONFIG: {
    BASE: '/v1/admin/map-discovery-config',
  },
  LOCATION_LIKE_CONFIG: {
    BASE: '/v1/admin/location-like-config',
  },
  CHECK_IN_CONFIG: {
    BASE: '/v1/admin/check-in-config',
  },
  LOCATION_LIKES: {
    PLACES: '/v1/admin/location-likes/places',
    PLACE_DETAIL: (id: string) => `/v1/admin/location-likes/places/${id}`,
  },
  CHALLENGES: {
    LIST: '/v1/admin/challenges',
    DETAIL: (id: string) => `/v1/admin/challenges/${id}`,
    CREATE: '/v1/admin/challenges',
    UPDATE: (id: string) => `/v1/admin/challenges/${id}`,
    STATUS: (id: string) => `/v1/admin/challenges/${id}/status`,
    EXTEND: (id: string) => `/v1/admin/challenges/${id}/extend`,
    REOPEN: (id: string) => `/v1/admin/challenges/${id}/reopen`,
    ENABLE: (id: string) => `/v1/admin/challenges/${id}/enable`,
    DISABLE: (id: string) => `/v1/admin/challenges/${id}/disable`,
    GPS_LOCATIONS: '/v1/admin/challenges/gps-locations',
    GPS_LOCATION_FILTER_OPTIONS: '/v1/admin/challenges/gps-locations/filter-options',
    GPS_LOCATION_DETAIL: (id: string) => `/v1/admin/challenges/gps-locations/${id}`,
    GPS_LOCATION_DEACTIVATE: (id: string) => `/v1/admin/challenges/gps-locations/${id}/deactivate`,
    SUBMISSIONS: '/v1/admin/challenges/submissions',
    SUBMISSION_DETAIL: (id: string) => `/v1/admin/challenges/submissions/${id}`,
    SUBMISSION_APPROVE: (id: string) => `/v1/admin/challenges/submissions/${id}/approve`,
    SUBMISSION_REJECT: (id: string) => `/v1/admin/challenges/submissions/${id}/reject`,
    SUBMISSION_BULK_APPROVE: '/v1/admin/challenges/submissions/bulk-approve',
    SUBMISSION_BULK_REJECT: '/v1/admin/challenges/submissions/bulk-reject',
    WALLETS: '/v1/admin/challenges/wallets',
    WALLET_TRANSACTIONS: (userId: string) => `/v1/admin/challenges/wallets/${userId}/transactions`,
    WALLET_CREDIT: (userId: string) => `/v1/admin/challenges/wallets/${userId}/credit`,
    PAYOUTS: '/v1/admin/challenges/payouts',
    PAYOUT_APPROVE: (id: string) => `/v1/admin/challenges/payouts/${id}/approve`,
    PAYOUT_PROCESS: (id: string) => `/v1/admin/challenges/payouts/${id}/process`,
    PAYOUT_REJECT: (id: string) => `/v1/admin/challenges/payouts/${id}/reject`,
    PAYOUT_SIMULATE_PAID: (id: string) => `/v1/admin/challenges/payouts/${id}/simulate-paid`,
    PAYOUT_SIMULATE_FAILED: (id: string) => `/v1/admin/challenges/payouts/${id}/simulate-failed`,
    PARTICIPANTS: (id: string) => `/v1/admin/challenges/${id}/participants`,
    DISQUALIFY_USER: (id: string) => `/v1/admin/challenges/${id}/disqualify-user`,
    REFRESH_LEADERBOARD: (id: string) => `/v1/admin/challenges/${id}/refresh-leaderboard`,
    LEADERBOARD: (id: string) => `/v1/admin/challenges/${id}/leaderboard`,
    WINNERS: (id: string) => `/v1/admin/challenges/${id}/winners`,
    DECLARE_WINNERS: (id: string) => `/v1/admin/challenges/${id}/declare-winners`,
    DISTRIBUTE_REWARDS: (id: string) => `/v1/admin/challenges/${id}/distribute-rewards`,
    TRANSACTIONS: '/v1/admin/challenges/transactions',
    BANK_ACCOUNTS: '/v1/admin/challenges/bank-accounts',
    BANK_ACCOUNT_DETAIL: (id: string) => `/v1/admin/challenges/bank-accounts/${id}`,
    BANK_ACCOUNT_VERIFY: (id: string) => `/v1/admin/challenges/bank-accounts/${id}/verify`,
    MAPBOX_GEOCODE: '/v1/admin/challenges/mapbox/geocode',
    MAPBOX_STATIC_MAP: '/v1/admin/challenges/mapbox/static-map',
    IMAGE_LIBRARY: '/v1/admin/challenges/image-library',
  },
  SETTINGS: {
    CURRENCY: '/v1/admin/settings/currency',
  },
  BANNERS: {
    LIST: '/v1/admin/banners',
    DETAIL: (id: string) => `/v1/admin/banners/${id}`,
  },
  REFERRALS: {
    SUMMARY: '/v1/admin/referrals/summary',
    CODES: '/v1/admin/referrals/codes',
    CODE_DETAIL: (id: string) => `/v1/admin/referrals/codes/${id}`,
    CODE_USAGES: (id: string) => `/v1/admin/referrals/codes/${id}/usages`,
    USAGES: '/v1/admin/referrals/usages',
    RETRY_REWARD: (usageId: string) => `/v1/admin/referrals/usages/${usageId}/retry-reward`,
  },
} as const;
